import { concatenateArrayBuffersAsync } from '@loaders.gl/loader-utils';
import { encodeTableAsGeojsonInBatches } from "./lib/encoders/geojson-encoder.js";
export const GeoJSONWriter = {
  id: 'geojson',
  version: 'latest',
  module: 'geojson',
  name: 'GeoJSON',
  extensions: ['geojson'],
  mimeTypes: ['application/geo+json'],
  text: true,
  options: {
    geojson: {
      featureArray: false,
      geometryColumn: null
    }
  },
  async encode(table, options) {
    const tableIterator = [table];
    const batches = encodeTableAsGeojsonInBatches(tableIterator, options);
    return await concatenateArrayBuffersAsync(batches);
  },
  encodeInBatches: (tableIterator, options) => encodeTableAsGeojsonInBatches(tableIterator, options)
};
//# sourceMappingURL=geojson-writer.js.map